var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animate-spin before:absolute before:block before:h-full before:w-full before:rounded-full before:border-opacity-30 after:absolute after:block after:h-full after:w-full after:rounded-full after:border-transparent",class:[_vm.colorClassName, _vm.widthClassName]})
}
var staticRenderFns = []

export { render, staticRenderFns }